<template>
  <!--文章详情-->
  <div class="pdBtm30 pdTop30">
    <h1 class="tct col101010">{{info.title}}</h1>
    <h4 class="col101010 tct">
      <span v-if="info.author" class="mrRit10">作者:{{info.author}}</span>
      <span class="mrRit10">浏览量:{{info.views}}</span>
      <span class="col666">{{info.publishtime}}</span>
    </h4>
    <div class="fs14 col101010 mrTop20" style="min-height: 45rem">
      <div class="parse" v-html="info.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "articleDetail",
  data() {
    return {
      info: {
        id: '',
        title: '',
        content: '',
        publishtime: '',
        author: '',
        views: '',
      },
      id: '',
    }
  },
  methods: {
    getDetail(id) { //获取文章详情
      this.$axios("POST","/index/cms_archives_info",{id},'加载中')
      .then(res => {
        if(res.code===1) {
          this.info = res.data
        }else {
          this.$alert(res.msg)
        }
      })
    },
  },
  created() {
    let id = this.$route.query.id
    if(id) this.getDetail(id)
  },
}
</script>

<style scoped>

</style>